// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_sharePropertyDraftV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["SharedDraftV5"]);
}

let variablesConverter = {"sharePropertyDraftV5Input":{"contacts":{"r":"sharingContactV5Input"}},"sharingContactV5Input":{},"__root":{"input":{"r":"sharePropertyDraftV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"sharePropertyDraftV5_SharedDraftV5_draft_sharedWithContacts":{"f":""},"sharePropertyDraftV5":{"u":"response_sharePropertyDraftV5"}}};

let wrapResponseConverterMap = {
  response_sharePropertyDraftV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"sharePropertyDraftV5_SharedDraftV5_draft_sharedWithContacts":{"f":""},"sharePropertyDraftV5":{"u":"response_sharePropertyDraftV5"}}};

let responseConverterMap = {
  response_sharePropertyDraftV5: unwrap_response_sharePropertyDraftV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareDraftModal_ShareDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharePropertyDraftV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftV5",
                "kind": "LinkedField",
                "name": "draft",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "sharedWithContacts",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ShareDraftModalSharedRecipientsList_contacts"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SharedDraftV5",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareDraftModal_ShareDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharePropertyDraftV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftV5",
                "kind": "LinkedField",
                "name": "draft",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "sharedWithContacts",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isSharingContactV5"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "type": "SharingContactClientContactV5",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "type": "SharingContactFreshContactV5",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SharedDraftV5",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ffdc3f03c3fabe33c68f9b59d5b908c",
    "id": null,
    "metadata": {},
    "name": "ShareDraftModal_ShareDraftMutation",
    "operationKind": "mutation",
    "text": "mutation ShareDraftModal_ShareDraftMutation(\n  $input: SharePropertyDraftV5Input!\n) {\n  sharePropertyDraftV5(input: $input) {\n    __typename\n    ... on SharedDraftV5 {\n      databaseId\n      draft {\n        sharedWithContacts {\n          __typename\n          ...ShareDraftModalSharedRecipientsList_contacts\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ShareDraftModalSharedRecipientsList_contacts on SharingContactV5 {\n  __isSharingContactV5: __typename\n  __typename\n  ... on SharingContactClientContactV5 {\n    databaseId\n    firstName\n    lastName\n    email\n  }\n  ... on SharingContactFreshContactV5 {\n    databaseId\n    email\n  }\n}\n"
  }
};
})());

let wrap_response_sharePropertyDraftV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_sharePropertyDraftV5 = unwrap_response_sharePropertyDraftV5;
exports.wrap_response_sharePropertyDraftV5 = wrap_response_sharePropertyDraftV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
